import CartSimpleView from './CartSimpleView'
export default CartSimpleView
